import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { colors, spacing, styleIf, useStylesFor as stylesFor } from '@sine/sine-ui-components';

import { BOX_SHADOW } from '../../styles/common/misc';
import { SCREEN_LG_MIN } from '../../styles/common/sizes';

const Tab = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: 105px;
  width: 120px;
  padding: ${spacing(2)} ${spacing(1)};
  cursor: pointer;

  @media (min-width: ${SCREEN_LG_MIN}) {
    padding: ${spacing(2)} ${spacing(4)};
  }

  ${({ active }) =>
    styleIf(!active)`
      &:hover {
        background-color: ${colors.grey200};
        border-color: ${colors.grey300};
      }
    `}

  ${({ active }) =>
    styleIf(active)`
      background-color: ${colors.white};
      margin-bottom: -1px;
      margin-top: -2px;
      box-shadow: ${BOX_SHADOW};
      border-left: 1px solid ${colors.grey300};
      border-right: 1px solid ${colors.grey300};
      border-color: ${colors.grey100};

      &::before {
        content: ' ';
        height: 0;
        width: 0;
        margin-left: -13px;
        border: 13px solid transparent;
        border-top-color: #e5e5e5;

        position: absolute;
        top: 100%;
        left: 50%;

        pointer-events: none;
      }

      &::after {
        content: ' ';
        height: 0;
        width: 0;
        margin-left: -10px;
        border: 10px solid transparent;
        border-top-color: ${colors.white};

        position: absolute;
        top: 100%;
        left: 50%;

        pointer-events: none;
      }
    `}
`;

const TabTitle = styled.div`
  text-align: center;
  white-space: nowrap;
  display: block;
  font-size: 14px;
`;

const TabStatistic = styled.div`
  text-align: center;
  white-space: nowrap;
  display: block;
  font-size: 30px;
  font-weight: bold;
  color: ${({ color }) => color};
`;

const RightContent = styled.div`
  flex-grow: 1;
  align-items: flex-end;
`;

const TabsWrapper = styled.div`
  display: flex;
  padding: 0 ${stylesFor('tablet').andLarger`
    ${spacing(3)}
  `};
  max-width: 100%;

  ${stylesFor('tablet').andSmaller`
    overflow-y: hidden;
    overflow-x: scroll;
  `};
  /* overflow-x: auto;
  overflow-y: visible; */
`;

export default function BigTabs({ tabs, selectedTab, onTabChange, rightContent }) {
  return (
    <TabsWrapper>
      {tabs.map((tab) => (
        <Tab
          key={tab.id}
          active={tab.id === selectedTab.id}
          onClick={() => onTabChange(tab)}
          data-st-ext={tab.dataStExt}
        >
          <TabTitle>{tab.title}</TabTitle>
          <TabStatistic color={tab.color}>{tab.value}</TabStatistic>
        </Tab>
      ))}

      {rightContent && <RightContent>{rightContent}</RightContent>}
    </TabsWrapper>
  );
}

const TabPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType(PropTypes.string, PropTypes.number).isRequired,
  color: PropTypes.string.isRequired,
});

BigTabs.propTypes = {
  tabs: PropTypes.arrayOf(TabPropType).isRequired,
  selectedTab: TabPropType.isRequired,
  onTabChange: PropTypes.func.isRequired,
  rightContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
